import { CSSProperties } from '@mui/styles';
import { Box, Typography } from '@mui/material';

import { IconType } from '../icon';

interface Props {
  Icon: IconType;
  text: string;
  color: CSSProperties['color'];
}

const StatusElement = ({ Icon, text, color }: Props) => (
  <Box display="flex" alignItems="center">
    <Icon style={{ color }} />
    <Box pl={1}>
      <Typography style={{ color }} variant="h4">
        {text}
      </Typography>
    </Box>
  </Box>
);

export default StatusElement;
